import { ParseKeys } from 'i18next'

import { VideoPlayerFeatures, VideoPlayerLabels } from './VideoPlayer.types'

export const DEFAULT_VIDEO_PLAYER_FEATURES: Required<VideoPlayerFeatures> = {
  playPause: true,
  currentTime: true,
  duration: true,
  seek: true,
  volume: true,
  playbackRate: true,
  fullscreen: true
}

export const VIDEO_PLAYER_LABEL_KEYS = {
  video: 'video_player.video',
  play: 'video_player.play',
  pause: 'video_player.pause',
  seek: 'video_player.seek',
  volume: 'video_player.volume',
  mute: 'video_player.mute',
  unmute: 'video_player.unmute',
  playbackSpeed: 'video_player.playback_speed',
  enterFullscreen: 'video_player.enter_fullscreen',
  exitFullscreen: 'video_player.exit_fullscreen'
} satisfies Record<keyof VideoPlayerLabels, ParseKeys<'translation'>>

export const DEFAULT_CONTROLS_HIDE_DELAY = 2000

export const PLAYBACK_RATES: ReadonlyArray<number> = [
  0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2
]
